/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blank_FramesInputs */

const en_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blank Frames...`)
};

const fr_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images vides...`)
};

const de_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Rahmen...`)
};

const it_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cornici vuote...`)
};

const ru_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пустые рамки...`)
};

const es_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcos en blanco...`)
};

const zh_cn2_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白相框……`)
};

const ja_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白のフレーム...`)
};

const hi_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाली फ्रेम...`)
};

const pt_pt2_blank_frames = /** @type {(inputs: Blank_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molduras em branco...`)
};

/**
* | output |
* | --- |
* | "Blank Frames..." |
*
* @param {Blank_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const blank_frames = /** @type {((inputs?: Blank_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blank_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_blank_frames(inputs)
	if (locale === "de") return de_blank_frames(inputs)
	if (locale === "it") return it_blank_frames(inputs)
	if (locale === "ru") return ru_blank_frames(inputs)
	if (locale === "es") return es_blank_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_blank_frames(inputs)
	if (locale === "ja") return ja_blank_frames(inputs)
	if (locale === "hi") return hi_blank_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_blank_frames(inputs)
	return en_blank_frames(inputs)
});